import LoginPage from './loginPage.component';

export default LoginPage;